
import React from 'react'

interface OutboundBuddyLogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  animated?: boolean
}

export function OutboundBuddyLogo({ 
  size = 'md', 
  className = '', 
  animated = false 
}: OutboundBuddyLogoProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12', 
    lg: 'w-16 h-16'
  }

  return (
    <div className={`${sizeClasses[size]} ${className} ${animated ? 'animate-spin-slow' : ''}`}>
      <img 
        src="/lovable-uploads/89b00559-46c3-44ea-9cd2-0f26ef283839.png" 
        alt="Outbound Buddy Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  )
}
